import { pick } from 'lodash';
import {
  AlignParameters,
  CellAlignment,
  ContainerAnimationConfig,
  ContainerShapeDescriptor,
  Coords,
  ShapeConfig,
  ShapeSelectParams,
  TextShapeDescriptor,
  Translate,
} from '../../../../elements/resource/types/shape.type';
import {
  _setRelationshipBase,
  bulkUpdateFinish,
  removeContainerMenuItem,
  setChangeTookPlace,
  setRelationship,
} from '../../../store/editor.actions';
import {
  deleteShapeAction,
  setDescriptorValue,
} from '../../../store/editor.crud.actions';
import { GeneralShape } from '../general/general-shape';
import {
  AnimationFrame,
  AutoAnimationFrame,
} from '../../../animation/components/animation-frame/animation.types';
import { ResourceData } from '../../../../elements/resource/resource.types';
import {
  RCPoint,
  RectangleController,
  RectangleDragResponse,
} from '../../../../elements/util/rectangle-controller/rectangle-controller';
import { baseDescriptorByIRI } from '../../../store/selector/editor.selector';
import { ShapeService } from '../../shape.service';
import { PathElement } from '../primitive/path-element';
import { PlaceholderShape } from '../placeholder/placeholder-shape';
import { ImageShapeConfig } from '../base/image-shape';

export class ContainerShape<
  T extends ContainerShapeDescriptor = ContainerShapeDescriptor,
> extends GeneralShape<T> {
  itemDelimiters: PathElement[] = [];

  constructor(
    service: ShapeService,
    data: ResourceData<T>,
    config?: ShapeConfig,
  ) {
    super(service, data, config);
    this.init();
  }
  init() {
    super.init();
    this.initShapes();
    if (this.config?.forceAlign && this.cellAlignment) {
      console.log('init > forceAlign ', this.getType(), this.cellAlignment);
      console.log(
        'init > forceAlign ',
        this.shapes.map(shape => shape.IRI),
      );
      // -- //
      this.alignItems({ save: true });
    }
  }
  getType() {
    return 'container-shape';
  }

  afterInit(): void {
    super.afterInit();
    this.shapes.map(shape => shape.afterInit());
    this.setChildIndexes();

    // if (this.config?.isRoot) {
    this.subscriptions.push(
      this.store.select(baseDescriptorByIRI<T>(this.IRI)).subscribe(value => {
        // this.config.topology = value?.topology; // -- //
        // if (this.descriptor.topology == value?.topology) {
        if (!value || Object.keys(value).length == 0) {
          return;
        }
        // this.shapes.map(shape => shape.showContainerItemRC());
        // this.alignItems();
        // }
        // this.descriptor.topology = value?.topology;
        // this.alignRootShape(); // -- //
      }),
    );

    this.applyTranslate(this.translate);

    if (this.cellAlignment) {
      const { w, h } = this.cellAlignment;

      if (this.getType() == 'container-shape') {
        return;
      }

      return;
      this.rc = new RectangleController(
        this,
        {
          width: w,
          height: h,
          // showRectangle: true,
          offset:
            this.getType() !== 'root-shape' ? [this.x, this.y] : undefined,
          // fill: true,
          // hiddenMode: true,
          noStroke: true,
          noFill: true,
          skipRC: {
            'center-top': true,
            'left-center': true,
            'right-center': true,
            'center-bottom': true,
          },
          // Wire RC events to shape methods for drag-based cellAlignment updates
          startDrag: p => this.rcStartDrag(p),
          drag: resp => this.rcDrag(resp),
          endDrag: p => this.rcEndDrag(p),
          // mouseover: () => {
          //   console.log('mouse-over');
          //   if (this.selected) {
          //     return;
          //   }
          //   this.setContainerMenuItem();
          //   this.rc.show({ onHover: true });
          //   this.showItemDelimiters();
          // },
          // mouseout: () => {
          //   console.log('mouse-out');
          //   if (this.selected) {
          //     return;
          //   }
          //   console.log('mouseout');
          //   // this.setContainerMenuItem();
          //   this.rc.hide({ onHover: true });
          //   this.clearDelimiters();
          // },
          clicked: () => {
            // if (!this.selected) {
            //   this.rc.setNoneEventMode();
            //   return this.select();
            // }
          },
          doubleClicked: () => {
            console.log('container.doubleClick');
          },
        },
        this.circleContainer,
        this.auxCircleContainer,
        this.container,
      );

      this.rc.hidePointControllers();
      this.rc.hide();
    }

    this.shapes.map(shape => shape.disablePointerEvents());
    // this.alignItems();
  }

  setContainerState(state: 'active' | 'hover' | 'passive') {
    // super.setHoverState(state);

    // console.log('-- container-shape > setContainerState', state);
    super.setContainerState(state);
    switch (state) {
      case 'active':
        if (this.shapes.length == 1) {
          this.shapes[0].enablePointerEvents();
        }
        break;
      default:
        this.shapes.map(shape => shape.disablePointerEvents());
        break;
    }
  }

  addTextShape() {
    // console.log('-------------add-tex-shape---------------');

    const textShape = this.service.addNewShapeByResourceData(
      {
        IRI: this.service.getNewIRI(),
        type: 'nw:Shape',
        literals: {
          descriptor: {
            type: 'text-shape',
            textConfig: {
              text: '',
              fontSize: 16,
            },
          } as TextShapeDescriptor,
        },
        relationships: {
          file: this.cs.previewShape.IRI,
          childOf: this.IRI,
        },
      },
      { initialType: 'text' },
    );

    this.finishUpdate();
    this.store.dispatch(setChangeTookPlace());
    this._shapes.push(textShape);
    this.alignItems();
    this.setContainerIndexes();
    this.store.dispatch(removeContainerMenuItem({ IRI: this.IRI }));
  }

  rcStartDrag(p: RCPoint) {
    this.dragMode = p as 'top' | 'bottom' | 'left' | 'right';
    this.currentHeight = this.cellAlignment?.h;
    this.unmovedCellAlignment = { ...this.cellAlignment };
  }
  rcDrag(resp: RectangleDragResponse) {
    console.log(
      '-------- rc-drag ---------',
      this.rc.config.width,
      this.rc.config.height,
    );
    this.rc.rect.show();
    this.rc.container.visible = true;
    this.rc.rect.patch({
      'stroke-width': 1,
    });
    // Implement RC-based cellAlignment update for root-shape
    if (this.getType() !== 'root-shape') {
      return;
    }
    const { dx, dy, height, width } = resp || {};

    // console.log('rc-drag', resp);

    if (height == null) {
      return;
    }

    const { x, y } = this.unmovedCellAlignment;

    // Keep centered: derive uniform margin from height; width follows from margin
    // Update descriptor + alignment
    // this.descriptor.margin = newMargin;
    // const newAlignment: CellAlignment = {
    //   x: newMargin,
    //   y: newMargin,
    //   w: newWidth,
    //   h: height,
    //   align: 'center',
    // };

    // Apply to root and recursively realign children
    this.doAlign(
      {
        x: x + dx,
        y: y + dy,
        w: width,
        h: height,
        align: 'center',
      },
      { recursive: true },
    );
    // this.showItemDelimiters();
  }

  rcEndDrag(point?: RCPoint) {
    // For now, nothing to persist explicitly; alignment already applied in rcDrag
    this.dragMode = null;
    this.currentHeight = null;
  }

  removeItem(shape: GeneralShape) {
    const index = this.shapes.findIndex(s => s.IRI === shape.IRI);

    if (index === -1) {
      console.warn('Shape not found in container:', shape.IRI);
      return;
    }

    // Remove shape from container's shapes array //
    this._shapes = this.shapes.filter(s => s.IRI !== shape.IRI);

    // Clean up the shape itself

    // Remove from store
    // -- // -- // -- // -- // -- // -- // -- // -- // -- // -- //

    this.store.dispatch(deleteShapeAction({ IRI: shape.IRI }));

    // Re-align remaining items and update container indexes //
    this.alignItems();
    this.setContainerIndexes();

    // Show container item RCs for remaining shapes
    // this.shapes.map(remainingShape => remainingShape.showContainerItemRC());

    shape._remove();
    // Dispatch bulk update finish

    if (this.parent && this.shapes.length == 1) {
      // so I am not the rootShape - later
      //console.log('parent-remove > -------');
      // -- // -- // -- //
      const [onlyChild] = this.shapes;
      // this.remove();
      (this.parent as ContainerShape).addShape({
        shape: onlyChild,
        index: this.index,
        containerIndex: this.containerIndex,
      });
      this.store.dispatch(deleteShapeAction({ IRI: this.IRI }));
      // -- //
    }

    this.finishUpdate();
  }

  _remove() {
    super.remove();
    this.shapes.map(shape => shape._remove());
  }

  _addShape(params: {
    type: 'text' | 'image' | 'container';
    base64?: string;
    containerIndex?: number;
    index?: number;
  }): GeneralShape {
    // -- //
    const { type, base64 } = params;
    // -- //

    const shape = this.service.addNewShapeByResourceData(
      {
        literals: {
          descriptor: {
            type: type + '-shape',
            position: { x: 0, y: 0 },
            textConfig:
              type == 'text'
                ? {
                    text: '',
                    fontSize: 14,
                  }
                : undefined,
          } as TextShapeDescriptor,
        },
        relationships: {
          parent: this.IRI,
          file: this.cs.previewShape.IRI,
        },
      },
      {
        base64,
        ...(type === 'text' ? { initialType: 'text' } : {}),
      } as ImageShapeConfig,
    );

    // -- //

    return shape;
  }

  addShape(params: {
    type?: 'text' | 'image' | 'container';
    base64?: string;
    containerIndex?: number;
    index?: number;
    shape?: GeneralShape;
    cellAlignment?: CellAlignment;
    push?: boolean;
  }) {
    const { type, base64, containerIndex, cellAlignment, push } = params;

    let { shape, index } = params;
    if (index == undefined) {
      index = this.shapes.length;
    }

    if (shape) {
      // -- //
      this.store.dispatch(
        _setRelationshipBase({
          subject: shape.IRI,
          relationship: 'childOf',
          object: this.IRI,
          save: true,
        }),
      );
      if (containerIndex != undefined) {
        shape.containerIndex = containerIndex;
      }
      if (cellAlignment) {
        shape.cellAlignment = cellAlignment;
        shape.saveDescriptorKey('cellAlignment', cellAlignment);
      }

      if (index != undefined) {
        shape.index = index;
        shape.saveDescriptorKey('index', index);
      }

      //shape.save();
    }

    shape ||= this.service.addNewShapeByResourceData(
      {
        type: 'nw:Shape',
        literals: {
          descriptor: {
            type: type + '-shape',
            index,
            position: { x: 0, y: 0 },
            cellAlignment,
            textConfig:
              type == 'text'
                ? {
                    text: 'Text',
                    fontSize: 14,
                  }
                : undefined,
          } as TextShapeDescriptor,
        },
        relationships: {
          childOf: this.IRI,
          file: this.cs.previewShape.IRI,
        },
      },
      {
        base64,
        containerIndex,
        ...(type === 'text' ? { initialType: 'text' } : {}),
        // forceAlign: type == 'container',
      } as ImageShapeConfig,
      true,
    );

    // -- // -- // -- //

    if (containerIndex == undefined) {
      this._shapes.push(shape);
    } else {
      if (push) {
        this._shapes.splice(containerIndex, 0, shape);
      } else {
        this._shapes[containerIndex] = shape;
      }
    }
    // this.setContainerIndexes();
    return shape;
  }

  addItemAfter(shape: GeneralShape) {
    this.addHorizontal(shape, 'after');
  }

  addItemBefore(shape: GeneralShape) {
    this.addHorizontal(shape, 'before');
  }

  addHorizontal(shape: GeneralShape, type: 'before' | 'after') {
    const [index, containerIndex, cellAlignment] = [
      shape.descriptor.index,
      shape.containerIndex,
      shape.cellAlignment,
    ];

    shape.removeContainersFromParent();
    // -- // -- //

    switch (type) {
      case 'before':
        shape.index = 1;
        break;
      case 'after':
        shape.index = 0;
        break;
    }
    shape.saveDescriptorKey('index', shape.index);

    if (
      this.descriptor.topology == 'column' ||
      this.cellAlignment.topology == 'column'
    ) {
      const containerShape = this.addShape({
        type: 'container',
        index,
        containerIndex,
        cellAlignment: {
          ...cellAlignment,
          topology: 'row',
        },
      }) as ContainerShape;
      // -- // -- //

      if (type == 'before') {
        containerShape.addShape({
          type: 'container',
        });
        containerShape.addShape({ shape });
      } else {
        containerShape.addShape({ shape });
        containerShape.addShape({
          type: 'container',
        });
      }

      containerShape.alignItems({ save: true });
      // -- //
      containerShape.showContainerItemRC();
      containerShape.select();

      // -- // -- //
    } else {
      // -- // -- //

      let newShape: GeneralShape;
      switch (type) {
        case 'before':
          newShape = this.addShape({
            type: 'container',
            index: shape.prevInContainer
              ? (shape.index + shape.prevInContainer.index) / 2
              : shape.index - 1,
            containerIndex,
            // -- // -- //
            push: true,
          });
          break;
        case 'after':
          newShape = this.addShape({
            type: 'container',
            index: shape.nextInContainer
              ? (shape.index + shape.nextInContainer.index) / 2
              : shape.index + 1,
            containerIndex: containerIndex + 1,
            push: true,
          });
          break;
      }
      this.alignItems({ save: true });

      newShape.showContainerItemRC();
      // -- // shape.select(); // -- //
    }

    this.finishUpdate();
  }

  _addTextShape(shape?: GeneralShape) {
    // -- // -- // -- //

    const [index, containerIndex, cellAlignment] = shape
      ? [shape.descriptor.index, shape.containerIndex, shape.cellAlignment]
      : [
          0,
          0,
          {
            x: 0,
            y: 0,
            w: this.cellAlignment.w,
            h: this.cellAlignment.h,
          },
        ];

    this.addShape({
      type: 'text',
      index,
      containerIndex,
      cellAlignment,
    });

    shape?.remove({ noContainerRemove: true });
    this.finishUpdate();

    // -- // -- // -- //
    // return textShape;
    if (!shape) {
      this.clearContainerMenuItem();
      this.select();
    }
  }

  addAbove(shape: GeneralShape) {
    // -- // -- //

    this.addVertical(shape, 'before');
  }

  addBelow(shape: GeneralShape) {
    const topology =
      this.descriptor.topology || this.cellAlignment.topology || 'row';
    if (topology == 'row') {
      return this.addVertical(shape, 'after');
    }

    let index = shape.index + 1;
    if (shape.nextInContainer) {
      index = (shape.index + shape.nextInContainer.index) / 2;
    }

    this.addShape({
      type: 'container',
      index,
      containerIndex: shape.containerIndex + 1,
      push: true,
    });
    // -- // -- //
    this.alignItems();
  }

  addVertical(shape: GeneralShape, type: 'before' | 'after') {
    // -- // -- // Only implemented for row topology for now // -- // -- //

    const [index, containerIndex, cellAlignment] = [
      shape.descriptor.index,
      shape.containerIndex,
      shape.cellAlignment,
    ];

    switch (type) {
      case 'before':
        shape.index = 1;
        break;
      case 'after':
        shape.index = 0;
        break;
    }
    shape.saveDescriptorKey('index', shape.index);

    // -- // -- // -- //
    shape.removeContainersFromParent();
    // -- // -- // -- //
    if (!this.descriptor.topology || this.descriptor.topology == 'row') {
      // -- // -- // -- // -- // -- // -- //

      // console.log('addShape', { index, containerIndex }); //
      const containerShape = this.addShape({
        type: 'container',
        index,
        containerIndex,
        cellAlignment: {
          ...cellAlignment,
          topology: 'column',
        },
      }) as ContainerShape;

      if (type == 'before') {
        containerShape.addShape({
          type: 'container',
          index: 0,
        });
        containerShape.addShape({ shape, index: 1 });
      } else {
        containerShape.addShape({ shape, index: 0 });
        containerShape.addShape({
          type: 'container',
          index: 1,
        });
      }

      containerShape.alignItems({ save: true });
      // console.log(
      //   '----- lastAlignItem --',
      //   containerShape.shapes.map(shape => shape.IRI),
      // );
      containerShape.showContainerItemRC();
      containerShape.select();
    } else {
      // column // -- //
    }

    this.finishUpdate();
    return;
    // Create a new column container that will replace the reference shape
    const newColumn = this.service._addNewShapeByResourceData(
      {
        IRI: this.service.getNewIRI(),
        type: 'nw:Shape',
        literals: {
          descriptor: {
            type: 'container-shape',
            topology: 'column',
            index: shape.index,
            cellAlignment: shape.cellAlignment,
          },
        },
        relationships: {
          file: this.cs.previewShape?.IRI,
          childOf: this.IRI,
          shapes: {},
        },
      },
      {},
    ) as ContainerShape;

    newColumn.showContainerItemRC();
    newColumn.containerItemRC.setNoneEventMode();
    newColumn.doAlign(shape.cellAlignment);

    // Replace the original shape in this container with the new column container
    this._shapes.splice(index, 1, newColumn);

    // Re-parent the original shape under the new column container as the lower element
    try {
      shape.mainContainer.removeFromParent();
    } catch (e) {
      console.error('error removing shape from parent', e.message);
    }

    // Update store relationship and local descriptor
    shape.childOf = newColumn.IRI;
    this.store.dispatch(
      setDescriptorValue({
        IRI: shape.IRI,
        key: 'childOf',
        value: newColumn.IRI,
      }),
    );

    // Create the upper element as an empty container-shape (default row topology)
    const upperContainer = this.service._addNewShapeByResourceData(
      {
        IRI: this.service.getNewIRI(),
        type: 'nw:Shape',
        literals: {
          descriptor: {
            type: 'container-shape',
            topology: 'row',
            index: 0,
            cellAlignment: shape.cellAlignment,
          },
        },
        relationships: {
          file: this.cs.previewShape?.IRI,
          childOf: newColumn.IRI,
          shapes: {},
        },
      },
      {},
    ) as ContainerShape;

    upperContainer.showContainerItemRC();
    upperContainer.containerItemRC.setNoneEventMode();

    // Assemble children: upper container first, then the original shape
    newColumn._shapes = [upperContainer, shape];

    // Align and index updates
    newColumn.setContainerIndexes();
    newColumn.alignItems();
    newColumn.shapes.map(s => s.showContainerItemRC());

    this.setContainerIndexes();
    this.alignItems();
    this.finishUpdate();
  }

  addShapeAfter(refShape: GeneralShape) {
    // -- // -- //
    const index = this.shapes.findIndex(shape => shape.IRI == refShape.IRI);
    const nextShape = this.shapes[index + 1];
    const nextIndex = nextShape
      ? (refShape.index + nextShape.index) / 2
      : refShape.index + 1;

    const placeholderShape = this.service._addNewShapeByResourceData(
      {
        IRI: this.service.getNewIRI(),
        type: 'nw:Shape',
        literals: {
          descriptor: {
            position: {
              x: 0,
              y: 0,
            },
            type: 'placeholder-shape',
            index: nextIndex,
          },
        },
        relationships: {
          // In case of test there's no preview shape
          // TODO - it should be a shapeService variable
          file: this.cs.previewShape?.IRI,
          childOf: this.IRI,
        },
      },
      this,
    );
    // -- // -- // -- //
    this._shapes.splice(index + 1, 0, placeholderShape);
    this.setContainerIndexes();

    this.alignItems({ recursive: true });
    // Advanced alignment
    // const height = this.cellAlignment.h / this.shapes.length;
    // if (placeholderShape.nextInContainer) {
    //   placeholderShape.nextInContainer.updateAlign(
    //     {
    //       dy: height / 2,
    //       dh: -height / 2,
    //     },
    //     {
    //       save: true,
    //     },
    //   );
    //   placeholderShape.prevInContainer.updateAlign(
    //     {
    //       dh: -height / 2,
    //     },
    //     {
    //       save: true,
    //     },
    //   );
    // } else {
    //   placeholderShape.prevInContainer.updateAlign(
    //     {
    //       dh: -height,
    //     },
    //     {
    //       save: true,
    //     },
    //   );
    // }

    this.shapes.map(shape => shape.showContainerItemRC());
    this.finishUpdate();
  }

  addColumnShape(placeholder: GeneralShape) {
    const index = this.shapes.findIndex(shape => shape.IRI == placeholder.IRI);

    // Remove the placeholder
    placeholder.remove();
    this.store.dispatch(deleteShapeAction({ IRI: placeholder.IRI }));

    // Create new container with column topology
    const containerShape = this.service._addNewShapeByResourceData(
      {
        IRI: this.service.getNewIRI(),
        type: 'nw:Shape',
        literals: {
          descriptor: {
            position: {
              x: 0,
              y: 0,
            },
            type: 'container-shape',
            topology: 'column',
            index: placeholder.index,
            cellAlignment: placeholder.cellAlignment,
          },
        },
        relationships: {
          file: this.cs.previewShape.IRI,
          childOf: this.IRI,
          shapes: {},
        },
      },
      {},
    ) as ContainerShape;

    containerShape.showContainerItemRC();
    containerShape.containerItemRC.setNoneEventMode();

    // Apply alignment and replace in shapes array
    containerShape.doAlign(placeholder.cellAlignment);
    this._shapes.splice(index, 1, containerShape);

    this.shapes.map(shape => shape.showContainerItemRC());
    this.finishUpdate();
  }

  addRowShape(placholder?: GeneralShape) {
    let index = 0;
    if (placholder) {
      index = this.shapes.findIndex(shape => shape.IRI == placholder.IRI);

      // -- // -- //
      placholder.remove();
      this.store.dispatch(deleteShapeAction({ IRI: placholder.IRI }));
    }
    const containerShape = this.service._addNewShapeByResourceData(
      {
        IRI: this.service.getNewIRI(),
        type: 'nw:Shape',
        literals: {
          descriptor: {
            position: {
              x: 0,
              y: 0,
            },
            type: 'container-shape',
            topology: 'row',
            index: placholder?.index || 0,
            cellAlignment: placholder?.cellAlignment || {
              x: 0,
              y: 0,
              w: this.cellAlignment.w,
              h: this.cellAlignment.h,
              align: 'center',
            },
          },
        },
        relationships: {
          file: this.cs.previewShape.IRI,
          childOf: this.IRI,
          shapes: {},
        },
      },
      {},
    ) as ContainerShape;

    containerShape.showContainerItemRC();
    containerShape.containerItemRC.setNoneEventMode();

    // -- // -- //
    containerShape.doAlign(placholder?.cellAlignment);

    this._shapes.splice(index, 1, containerShape);

    // -- // -- // -- // -- //

    containerShape._shapes = [1, 2].map(val =>
      this.addPlaceHolderShape(val, containerShape.IRI),
    );
    // -- // -- // -- // -- // -- //
    containerShape.alignItems();
    containerShape.shapes.map(shape => shape.showContainerItemRC());

    // -- //

    containerShape.select();
  }

  removeContainerItemRCs() {
    console.log('removeContainerItemRCs');
    this.shapes.map(shape => shape.removeContainerItemRC(true));
  }

  getAbsCoords(): Coords {
    const { x, y } = this.cellAlignment;
    if (this.parent instanceof ContainerShape) {
      const [x0, y0] = this.parent.getAbsCoords();
      return [x + x0, y + y0];
    }
    return [x, y];
    // -- //
  }

  showItemDelimiters() {
    //this.clearDelimiters(); // Clear existing delimiters first
    return;
    if (this.shapes.length <= 1) {
      return; // No delimiters needed for single item or empty container
    }

    const { topology } = this.descriptor;
    const { w, h } = this.cellAlignment;
    const padding = 0.2; // 20% padding

    for (let i = 0; i < this.shapes.length - 1; i++) {
      // Create delimiters between items
      const prevShape = this.shapes[i - 1];

      let delimiterConfig: any;

      if (topology === 'column') {
        // Vertical line between items in column layout
        const y = prevShape.cellAlignment.y + prevShape.cellAlignment.h;
        const lineWidth = w * (1 - 2 * padding); // Apply 20% padding
        const startX = w * padding;

        delimiterConfig = {
          position: { x: startX, y },
          elements: [
            {
              type: 'line' as const,
              x: lineWidth,
              y: 0,
            },
          ],
          stroke: '#007bff',
          'stroke-width': 2,
          'stroke-opacity': 0.7,
        };
      } else {
        // Horizontal line between items in row layout
        const x = prevShape.cellAlignment.x + prevShape.cellAlignment.w;
        const lineHeight = h * (1 - 2 * padding); // Apply 20% padding
        const startY = h * padding;

        delimiterConfig = {
          position: { x, y: startY },
          elements: [
            {
              type: 'line' as const,
              x: 0,
              y: lineHeight,
            },
          ],
          stroke: '#007bff',
          'stroke-width': 2,
          'stroke-opacity': 0.7,
        };
      }

      const delimiter = new PathElement(
        this,
        this.circleContainer,
        delimiterConfig,
      );

      this.itemDelimiters.push(delimiter);
    }
  }

  clearDelimiters() {
    this.itemDelimiters.forEach(delimiter => delimiter.remove());
    this.itemDelimiters = [];
  }

  remove() {
    // Clean up item delimiters before removing the container
    this.clearDelimiters();
    super.remove();
  }

  addPlaceHolderShape(index: number, containerIRI: string) {
    return this.service._addNewShapeByResourceData({
      IRI: this.service.getNewIRI(),
      type: 'nw:Shape',
      literals: {
        descriptor: {
          position: {
            x: 0,
            y: 0,
          },
          type: 'placeholder-shape',
          index,
        },
      },
      relationships: {
        file: this.cs.previewShape.IRI,
        childOf: containerIRI,
      },
    });
  }

  deselect(params?: ShapeSelectParams) {
    super.deselect(params);
    // console.log('container-shape > deselect', this);
    // console.log('container-shape > deselect', this.shapes);
    this.rc?.hide();
    this.rc?.setAutEventMode();
    this.shapes.map(shape => shape.hideContainerItemRC());
    this.clearDelimiters(); // Hide delimiters when container is deselected
  }

  replaceShape(IRI: string, shape: GeneralShape) {
    const index = this.shapes.findIndex(s => s.IRI == IRI);
    // console.log('replaceShape > index', index); // -- //
    this._shapes[index] = shape;
    this.shapes.map(shape => shape.showContainerItemRC());
  }

  replacePlaceholderWithImage(
    shape: PlaceholderShape,
    base64: string,
    IRI: string,
  ) {
    const imageShape = this.service.addNewShape({
      label: 'image',
      IRI,
      descriptor: {
        type: 'image-shape',
        position: { translate: { x: 0, y: 0 } },
        cellAlignment: shape.cellAlignment,
      },
      relationships: {
        childOf: this.IRI,
        parent: this.IRI,
      },
      config: { base64 } as ImageShapeConfig,
    });

    this.replaceShape(shape.IRI, imageShape);
    shape.remove();
    this.store.dispatch(deleteShapeAction({ IRI: shape.IRI }));

    imageShape.doAlign(shape.cellAlignment);
    this.setContainerIndexes();
  }

  addPlaceholders(index = 0, type = 'row') {
    // -- // -- //

    if (type == 'row') {
      // replace placeholder shape with a container shape
      // -- // -- //
    }

    this.store.dispatch(
      setDescriptorValue({
        IRI: this.IRI,
        key: 'topology',
        value: type,
        direct: true,
      }),
    );

    this.store.dispatch(removeContainerMenuItem({ IRI: this.IRI }));

    if (index == 0) {
      this._shapes = [
        this.service.addPlaceholderShape(1),
        this.service.addPlaceholderShape(2),
      ];

      this.alignItems();
      this.shapes.map(shape => shape.showContainerItemRC());

      // this.store.dispatch(
      //   setDescriptorValue({
      //     IRI: this.IRI,
      //     key: 'topology',
      //     value: type,
      //     direct: true,
      //   }),
      // );
    }

    // -- // -- //
  }

  getAutoAnimations(): AutoAnimationFrame[] {
    const animations = [
      {
        id: Math.random().toString(),
        duration: 0.016,
        // preDelay: 0.4, //
        targetShape: this.IRI,
        type: 'auto-animation',
        action: 'appear',
        // alignment: this.parent.getChildAlignment(1), // -- //
      } as AutoAnimationFrame,
    ];
    this.shapes.map(shape => {
      animations.push(...shape.getAutoAnimations());
    });
    // -- // -- //
    return animations;
  }

  initAutoAnimation() {
    if (!this.descriptor.simplifiedDescriptor) {
      return;
    }

    // v1 - row - appear in the middle
    // const { topology } = this.descriptor.simplifiedDescriptor;
  }
  doAlign(alignment: CellAlignment, params: AlignParameters = {}): Translate {
    super.doAlign(alignment, params);
    // -- // this.alignItems(); // -- //
    const { recursive } = params;
    if (recursive) {
      console.log('recursive');
      this.alignItems(params);
    }
    return this.translate;
  }
  deselectAsSibling(): void {
    if (this.selected) {
      this.showContainerItemRC();
    }
    super.deselectAsSibling();
    this.shapes.map(shape => shape.hideContainerItemRC());
  }

  select(params?: ShapeSelectParams) {
    super.select(params);
    // -- // -- // -- //
    // this.parent?.rc?.hide();
    // -- // -- // -- //
    // this.hideItemDelimiters();

    // That way the children's controllers will be available //
    this.containerItemRC?.disableActions();
    if (params?.onHover) {
      return;
    }
    this.shapes.map(shape => shape.showContainerItemRC());
  }

  unitHeight: number;
  unitWidth: number;

  _initShapes(shapeData: ResourceData[], merge = false) {
    // this.descriptor.containerDescriptor = pick(
    //   this.descriptor.simplifiedDescriptor,
    //   ['topology', 'alignItems', 'margin', 'gap'],
    // ) as ContainerDescriptor;

    if (!this.cellAlignment) {
      this._shapes = shapeData.map((resourceData, index) => {
        return this.service.initShape(resourceData, this, {
          containerIndex: index,
        });
      });
      return;
    }

    const { topology } = this.descriptor;
    const { w, h } = this.cellAlignment;

    // -- // -- // -- //
    let unitWidth: number;
    let unitHeight: number;

    switch (topology) {
      case 'column':
        unitWidth = w;
        unitHeight = h / shapeData.length;
        break;
      case 'row':
      default:
        unitWidth = w / shapeData.length;
        unitHeight = h;
        break;
    }

    const shapes = shapeData.map((resourceData, index) => {
      if (resourceData.literals.descriptor.cellAlignment) {
        return this.service.initShape(resourceData, this, {
          containerIndex: index,
        });
      }

      resourceData.literals.descriptor.position = {
        translate: { x: 0, y: 0 },
        scale: {
          x: 1,
          y: 1,
        },
      };

      const cellAlignment: CellAlignment = {
        w: unitWidth,
        h: unitHeight,
        x: topology == 'column' ? 0 : index * unitWidth,
        y: topology == 'column' ? index * unitHeight : 0,
        align: this.descriptor.containerDescriptor?.alignItems,
      };

      // console.log('initShapes > cellAlignment', resourceData);

      resourceData.literals.descriptor.cellAlignment = cellAlignment;
      return this.service.initShape(resourceData, this, {
        cellAlignment,
        containerIndex: index,
        saveAfterInit: true,
      });
    });

    if (merge) {
      this._shapes.push(...shapes);
    } else {
      this._shapes = shapes;
    }
  }

  alignShapes() {
    // -- //
    // First this is going to be invoked // -- //

    // After the cell alignmen is determined for the container shape
    // its cell's are going to be aligned

    const { topology } = this.descriptor.containerDescriptor;
    const { w, h } = this.cellAlignment;

    let unitWidth: number;
    let unitHeight: number;

    switch (topology) {
      case 'column':
        unitWidth = w;
        unitHeight = h / this.shapes.length;
        break;
      case 'row':
      default:
        unitWidth = w / this.shapes.length;
        unitHeight = h;
        break;
    }

    this.shapes.map((shape, index) => {
      const cellAlignment: CellAlignment = {
        w: unitWidth,
        h: unitHeight,
        x: topology == 'column' ? 0 : index * unitWidth,
        y: topology == 'column' ? index * unitHeight : 0,
        align: this.descriptor.containerDescriptor.alignItems,
      };
      shape.doAlign(cellAlignment);
    });
  }

  updateCellAlignment() {
    // -- // -- //
    // -- // -- //
  }

  alignItems(params: AlignParameters = {}) {
    let { topology } = this.descriptor;
    const { w, h, topology: cellTopology } = this.cellAlignment;

    topology ||= cellTopology;

    let unitWidth: number;
    let unitHeight: number;

    switch (topology) {
      case 'column':
        unitWidth = w;
        unitHeight = h / this.shapes.length;
        break;
      case 'row':
      default:
        unitWidth = w / this.shapes.length;
        unitHeight = h;
        break;
    }

    let currentY = 0;

    this.shapes.map((shape, index) => {
      const cellAlignment = {
        w: unitWidth,
        h: shape.baseDescriptor.cellHeight || unitHeight,
        x: topology == 'column' ? 0 : index * unitWidth,
        y: topology == 'column' ? currentY : 0,
        align: this.descriptor.containerDescriptor?.alignItems,
      };
      currentY += shape.baseDescriptor.cellHeight || unitHeight;
      shape.doAlign(cellAlignment, {
        save: true,
        updateRC: true,
        ...params,
      });
    });
  }

  resetBaseState(): void {
    super.resetBaseState();
    this.alignByContainer();
    this.shapes.map(shape => shape.resetBaseState());
    this.shapes.map(shape => shape.alignByContainer());
    this.setInitialState();
  }

  __setPreAnimationState(): void {
    console.log('container-shape > __setPreAnimationState');
    this.shapes.map(shape => shape._hide());
  }

  setPreAnimationState() {
    // TODO - check if it is the right thing
    this.shapes.map(shape => shape.setPreAnimationState());
    return super.setPreAnimationState();
  }

  getContainerAnimation(): AutoAnimationFrame {
    const res = {
      id: Math.random().toString(),
      duration: 1,
      targetShape: this.shapes[0].IRI,
      type: 'auto-animation',
      action: 'appear',
      alignment: this.getChildAlignment(1),
      next: {
        id: Math.random().toString(),
        duration: 1,
        targetShape: this.shapes[0].IRI,
        type: 'auto-animation',
        action: 'move',
        alignment: this.getChildAlignment(2, 0),
        next: {
          id: Math.random().toString(),
          type: 'auto-animation',
          duration: 1,
          targetShape: this.shapes[1].IRI,
          action: 'appear',
          alignment: this.getChildAlignment(2, 1),
        },
      },
    } as AutoAnimationFrame;

    console.log('getContainerAnimation', res);
    return res;
  }

  setChildIndexes() {
    this.shapesByIndex.map((shape, index) => {
      if (index > 0) {
        const prevShape = this.shapes[index - 1];
        shape.prev = prevShape;
        prevShape.next = shape;
      }
      shape.childIndex = index;
    });
  }

  alignHorizontally(
    dims: Coords,
    align: 'left' | 'center' | 'right' = 'center',
  ): number {
    // -- // -- //
    if (this.descriptor.simplifiedDescriptor) {
      const { margin } = this.descriptor.containerDescriptor;
      return margin;
    }
  }

  alignVertically(
    dims: Coords,
    align: 'left' | 'center' | 'right' = 'center',
  ): number {
    if (this.descriptor.simplifiedDescriptor) {
      const { margin } = this.descriptor.containerDescriptor;
      return margin;
    }
  }

  moveUp(shape: GeneralShape) {
    if (this._shapes.length == 1) {
      return;
    }

    if (shape.containerIndex == 0) {
      return;
    }
    if (isNaN(this.index)) {
      this.index = Math.random() * 100;
    }

    this.setContainerIndexes();
    this.containerForChildren.removeChild(shape.mainContainer);

    this.containerForChildren.addChildAt(
      shape.mainContainer,
      shape.containerIndex - 1,
    );

    const prevPrev = this.shapesByIndex[shape.containerIndex - 2];
    const prev = this.shapesByIndex[shape.containerIndex - 1];

    if (!prevPrev || prevPrev.index == prev.index) {
      shape.index = prev.index - 2;
    } else {
      shape.index = (prevPrev.index + prev.index) / 2;
    }

    this.setContainerIndexes();
    this.saveShapeIndex(shape);
  }

  moveDown(shape: GeneralShape) {
    if (this._shapes.length == 1) {
      return;
    }

    if (shape.containerIndex == this.containerForChildren.children.length - 1) {
      return;
    }
    this.setContainerIndexes();

    this.containerForChildren.removeChild(shape.mainContainer);

    this.containerForChildren.addChildAt(
      shape.mainContainer,
      shape.containerIndex + 1,
    );

    const nextNext = this.shapesByIndex[shape.containerIndex + 2];
    const next = this.shapesByIndex[shape.containerIndex + 1];

    if (!nextNext || nextNext.index == next.index) {
      shape.index = next.index + 1;
    } else {
      shape.index = (nextNext.index + next.index) / 2;
    }

    this.setContainerIndexes();
    this.saveShapeIndex(shape);
  }

  // setContainerIndexes() {
  //   this.shapesByIndex.map((shape, i) => (shape.containerIndex = i));
  // }

  get shapeIRIs() {
    return this.shapes.map(shape => shape.IRI);
  }

  selectFrom(index: number) {
    for (let i = index; 0 < i; i--) {
      if (this.shapes[i].selected) {
        break;
      } else {
        console.log('select-shape');
        this.shapes[i].select();
      }
    }
    for (let i = index; i < this.shapes.length; i++) {
      if (this.shapes[i].selected) {
        break;
      } else {
        console.log('select-shape');
        this.shapes[i].select();
      }
    }
  }

  saveShapeIndex(shape: GeneralShape) {
    this.store.dispatch(
      setDescriptorValue({
        IRI: shape.IRI,
        key: 'index',
        value: shape.index,
      }),
    );
    this.store.dispatch(bulkUpdateFinish());
  }

  moveUpwards(shape: GeneralShape) {
    // -- // -- // -- // -- //
    const indexes = this.shapeIndexes;
    this.fixUndefinedIndexes(indexes);

    const lastIndex = indexes[indexes.length - 1];
    this.setNewIndex(shape, lastIndex + 1);
  }

  setNewIndex(shape: GeneralShape, index: number) {
    console.log('set-new-index', index);
    try {
      shape.mainContainer.removeFromParent();
      // this.containerForChildren.removeChildAt(shape.childIndex);
    } catch (error) {
      console.warn('child-could not be removed', error.message);
    }

    shape.index = index;
    this.setChildIndexes();

    shape.save();
    console.log('up > add at', shape.childIndex);
    this.containerForChildren.addChildAt(shape.mainContainer, shape.childIndex);
  }

  moveDownwards(shape: GeneralShape) {
    console.log('move-downwards');
    return;
    const indexes = this.shapeIndexes;
    this.fixUndefinedIndexes(indexes);

    if (indexes.includes(null)) {
      for (const shape of this.shapes) {
        if (shape.index == null) {
          shape.index = 0;
          shape.save();
        }
      }
    }

    const firstIndex = indexes[0];
    this.containerForChildren.removeChildAt(shape.childIndex);

    if (firstIndex <= 0) {
      shape.index = firstIndex - 1;
    } else {
      shape.index = firstIndex / 2;
    }

    this.setChildIndexes();

    shape.save();
    this.containerForChildren.addChildAt(shape.mainContainer, 0);

    this._shapes = this._shapes.sort((c1, c2) => c1.index - c2.index);
  }

  fixUndefinedIndexes(indexes: number[]) {
    if (indexes.includes(null)) {
      for (const shape of this.shapes) {
        if (shape.index == null || shape.index == 0) {
          shape.index = 0;
          shape.save();
        }
      }
    }
  }

  getContainerAnimatioFrame({
    complete,
  }: { complete?: boolean } = {}): AnimationFrame {
    const { baseAnimations: animation } = this
      .baseDescriptor as ContainerShapeDescriptor;

    if (!animation) {
      return;
    }

    const { appear } = animation;
    const animations: AnimationFrame[] = [];
    switch ((appear as ContainerAnimationConfig).mode) {
      case 'shift':
        this.shapes.forEach((shape, i) => {
          const appearAnimation = shape.getAppearAnimation();
          appearAnimation.alignment = this.getChildAlignment(i + 1, i);
          animations.push(appearAnimation);

          if (i < this.shapes.length - 1) {
            animations.push({
              type: 'auto-animation',
              action: 'move',
              duration: 0.6,
              targetShape: shape.IRI,
              alignment: this.getChildAlignment(i + 2, i),
            } as AutoAnimationFrame);
          }
        });

        animations.push({
          type: 'auto-animation',
          action: 'disappear',
          duration: 0.6,
          targetShape: this.IRI,
        } as AutoAnimationFrame);

        if (complete) {
          animations.push({
            type: 'scene-transition',
            targetShape: this.IRI,
            duration: 0.6,
          });
        }
        break;

      case 'continous-shift':
        break;
      case 'fixed':
        this.shapes.forEach((shape, i) => {
          const appearAnimation = shape.getAppearAnimation();
          // appearAnimation.alignment = this.getChildAlignment(i + 1, i);
          animations.push(appearAnimation);

          // if (i < this.shapes.length - 1) {
          //   animations.push({
          //     type: 'auto-animation',
          //     action: 'move',
          //     duration: 0.6,
          //     targetShape: shape.IRI,
          //     alignment: this.getChildAlignment(i + 2, i),
          //   } as AutoAnimationFrame);
          // }
        });

      // return {
      //   type: 'auto-animation',
      //   action: 'appear',
      //   targetShape: this.shapes[0].IRI,
      //   alignment: this.getChildAlignment(2, 0),
      //   next: {
      //     type: 'auto-animation',
      //     action: 'appear',
      //     targetShape: this.shapes[1].IRI,
      //     alignment: this.getChildAlignment(2, 1),
      //   } as AutoAnimationFrame,
      // } as AnimationFrame;
    }

    // console.log('animations', animations);
    animations.reverse();

    return (animations || []).reduce((acc, animation, i) => {
      if (!acc) {
        return animation;
      }

      if ((animation as AutoAnimationFrame).action == 'move') {
        animation.paralell = acc;
        return animation;
      } else {
        animation.next = acc;
        return animation;
      }
    }, {});
  }
}
